/**
 * @preserve
 * Licenses of bundled dependencies can be found in dependencies-licenses.txt
 */
var DEFAULT_WORKBENCH_THEME="light";export{DEFAULT_WORKBENCH_THEME as D};
//# sourceMappingURL=themes-7f893bfa.js.map